import { gql } from '@apollo/client'

import { FRAGMENT as COURSE_COLLECTION_FRAGMENT } from '../../CourseCollectionCard'

export const COURSE_COLLECTIONS = gql`
  query CourseCollectionsSection($productCourseSlug: String) {
    productCollections(perPage: 2, productCourseSlug: $productCourseSlug) {
      nodes {
        ...CourseCollectionCardComponent
      }
    }
  }
  ${COURSE_COLLECTION_FRAGMENT}
`

export const COURSE_COLLECTIONS_EXTRA = gql`
  query CourseCollectionsSectionExtra {
    productCollections(perPage: 2) {
      nodes {
        ...CourseCollectionCardComponent
      }
    }
  }
  ${COURSE_COLLECTION_FRAGMENT}
`
